import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLang } from "./LangContext";
import { useSettings, getFaqAnswers } from "./SettingsContext";
import { ChapterHead, EASE, FadeUp, Soon } from "./Reveal";

export default function Faq() {
  const { t, lang } = useLang();
  const { settings } = useSettings();
  const f = t.faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="sss" className="section" data-testid="faq-section">
      <div className="wrap">
        <ChapterHead num={f.num} label={f.label} title={f.title} />
        <div className="faq-list">
          {f.items.map((item, i) => {
            const isOpen = open === i;
            const answers = getFaqAnswers(item, settings, t, lang);
            return (
              <FadeUp key={item.q} delay={i * 0.03}>
                <div className={`faq-item ${isOpen ? "open" : ""}`} data-testid={`faq-item-${i}`}>
                  <button
                    className="faq-trigger"
                    aria-expanded={isOpen}
                    data-testid={`faq-trigger-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                  >
                    <span>{item.q}</span>
                    <ChevronDown size={18} aria-hidden="true" />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        className="faq-body"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: EASE }}
                      >
                        <div className="faq-inner" data-testid={`faq-answer-${i}`}>
                          {answers.map((par, j) => (
                            <p key={j}>{par}</p>
                          ))}
                          {answers.length === 0 && <Soon text={f.pendingText} testid={`faq-soon-${i}`} />}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
